/**
 * Services accordion
 */

const services_init = function() {

  const wrapper = document.querySelector('.js-services');

  if (!document.body.contains(wrapper)) {
    return;
  }

  const services = wrapper.querySelectorAll('.js-service')
  const icons = wrapper.querySelectorAll('.js-service-x');
  const x = wrapper.querySelector('.js-services-x');
  
  // const toggle_service = (i) => {
  //   var service = services[i];

  //   services.forEach(sibling => {
  //     // sibling.classList.remove('active');
  //     // sibling.classList.add('hidden');
  //     sibling.classList.add('active');
  //   });
    
  //   // service.classList.remove('hidden');
  //   service.classList.add('active');
  // }

  const content_height = () => {
    let names = [];
    let descriptions = [];

    wrapper.querySelectorAll('.js-service-toggle').forEach(name => {
      names.push(name.offsetHeight);
    });

    wrapper.querySelectorAll('.js-service-description').forEach(desc => {
      desc.style.maxHeight = desc.offsetHeight + 'px';
      descriptions.push(desc.offsetHeight);
    });

    wrapper.style.height = 'calc(' + ((Math.max(...names) * 2) + Math.max(...descriptions)) + 'px + 10vw)';
  }

  content_height();

  const toggle_x = (i) => {
    const icon_src = x;
    const next_icon = icons[i];

    morph(icon_src, next_icon);

    icon_src.style.color = getComputedStyle(next_icon).color;
  }

  services.forEach((service, i) => {
    service.classList.add('active');

    service.querySelector('.js-service-toggle').addEventListener('mouseover', (e) => {
      e.stopPropagation();

      // toggle_service(i);
      toggle_x(i);
    });
  });

  const observer = new IntersectionObserver((entries, observer) => {
    if (entries[0].isIntersecting) {
      // toggle_service(0);
      toggle_x(0);

      observer.disconnect();
    }
  }, {
    threshold: 0.5
  });

  observer.observe(wrapper);

}

services_init();